

import numberCounter from "./components/number-counter";
import burgerMenu from "./components/burger-menu";
import aluAdaSwitch from "./components/alu-ada-switch";
import landingPageAnimation from "./components/landing-page";
import swiperHomepage from "./components/swiper-homepage";
import swiperAgencypage from "./components/swiper-agencypage";
import animAgencyPage from "./components/anim-agencypage";
import filtersButton from "./components/projects-filters";
import projectsFilters from "./components/projects-filters";
import swiperProjectpage from "./components/swiper-projectpage";
import newspage from "./components/newspage";
import scrollButtons from "./components/scroll";
import { CountUp } from './components/countUp.js';

numberCounter.init();
burgerMenu.init();
landingPageAnimation.init();
aluAdaSwitch.init();
swiperHomepage.init();
swiperAgencypage.init();
swiperProjectpage.init();
animAgencyPage.init();
projectsFilters.init();
newspage.init();
scrollButtons.init();